// src/components/MonacoEditor.js
import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import Editor from '@monaco-editor/react';
import { useTheme } from '@mui/material';

const MonacoEditor = forwardRef(function MonacoEditor({ value, language, onChange, onMount, options }, ref) {
  const theme = useTheme();
  const { mode } = theme.palette;
  const editorRef = useRef(null);

  const handleMount = (editor, monaco) => {
    editorRef.current = editor;
    // Trigger initial layout after mount
    setTimeout(() => editor.layout(), 50);
    if (onMount) {
      onMount(editor, monaco);
    }
  };

  useImperativeHandle(ref, () => ({
    layout: () => {
      if (editorRef.current) {
        setTimeout(() => {
          editorRef.current.layout();
        }, 10);
      }
    }
  }));

  return (
    <Editor
      height="100%"
      width="100%"
      language={language}
      theme={mode === 'dark' ? 'vs-dark' : 'light'}
      value={value}
      onMount={handleMount}
      onChange={onChange}
      options={{
        minimap: { enabled: false },
        wordWrap: 'on',
        scrollBeyondLastLine: false,
        automaticLayout: false,
        ...options,
      }}
    />
  );
});

export default MonacoEditor;